import axios from 'axios'

/**
 * Metricas visibles de la cocina OD del catering autenticado.
 *
 * No recibe ni envia un identificador de cocina: el backend lo resuelve desde
 * el token. Si algun dia aparece un `kitchen_id` en estas llamadas, es un bug
 * de aislamiento, no una feature.
 */
export default {
  /**
   * @param {string} [desde] fecha ISO (YYYY-MM-DD)
   * @param {string} [hasta] fecha ISO (YYYY-MM-DD)
   */
  obtener (desde, hasta) {
    return llamar('/foodcourt/metrics', desde, hasta)
  },

  /** Pedidos individuales con su tiempo de preparacion (tracking del data lake). */
  preparacion (desde, hasta) {
    return llamar('/foodcourt/metrics/preparacion', desde, hasta)
  },

  /**
   * Historico de disponibilidad: que platos se cayeron y que dia.
   *
   * Es el detalle hacia atras de "% Carta activa". La primera carga de un
   * periodo nuevo puede tardar varios segundos — el backend arma el rango
   * semana por semana desde el data lake y lo cachea una hora.
   */
  disponibilidad (desde, hasta) {
    return llamar('/foodcourt/metrics/disponibilidad', desde, hasta)
  }
}

function llamar (ruta, desde, hasta) {
  const params = {}
  if (desde) params.from = desde
  if (hasta) params.to = hasta

  return axios.get(ruta, { params }).then(
    respuesta => (respuesta.data && respuesta.data.payload) || {},
    error => {
      const respuesta = error.response || {}
      // 503 = el data lake no esta disponible. No es un error de la app ni
      // del catering: la pantalla lo muestra como "metricas no disponibles"
      // en vez de un error generico.
      if (respuesta.status === 503) {
        return { status: 'UNAVAILABLE', httpStatus: 503 }
      }
      console.error('[metricas-cocina] fallo la peticion', {
        ruta,
        status: respuesta.status || null,
        error: error.message
      })
      return Promise.reject(error)
    }
  )
}
